import { ESdChangeReason, LeftPanelType, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import { isLeftPanelButtonActive } from "./left-panel-rail";

export interface IScreensButtonState {}

export interface IScreensButtonProps {
  onMenuItemClick?: (panelType: LeftPanelType) => void;
}

class ScreensButton extends PureSdComponent<IScreensButtonProps & IWithSDProps, IScreensButtonState> {
  constructor(props: IScreensButtonProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    if (this.props.onMenuItemClick) {
      this.props.onMenuItemClick(LeftPanelType.Screens);
    } else {
      this.props.sd.setActiveLeftPanelByClick(LeftPanelType.Screens);
    }
  };

  render() {
    return (
      <>
        {this.props.sd.getVisibility(ViewPart.ScreensButton) === Visibility.Visible && (
          <KuikaButton
            data-testid="leftMenuScreensTabButton"
            data-onboarding-id="left_menu_screens"
            type="tertiary"
            size="md"
            isIcon
            color="neutral"
            active={isLeftPanelButtonActive(this.props.sd, LeftPanelType.Screens)}
            onClick={this.handleClick}
          >
            <KuikaSvg type="sidebar-icons" name="file" width={18} height={18} pointer />
          </KuikaButton>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const screensButton = withSD<IScreensButtonProps>(ScreensButton);
export { screensButton as ScreensButton };
